/* /src/components/auth/logoutCallback.jsx */

import React from "react";
import { AuthConsumer } from '../../contexts/authProvider';
import LoadingIndicator from '../wrapper/LoadingIndicator/LoadingIndicator';

export const LogoutCallback = () => (
    <AuthConsumer>
        {({ signoutRedirectCallback }) => {
            signoutRedirectCallback();
            return <LoadingIndicator active={true} />;
        }}
    </AuthConsumer>
);